import { createSelectionListViewContainer } from 'factories/SelectionListView'
import itemConditions from 'options/assets/itemConditions'
import { wrapItems } from 'helpers/utils'
import { t } from 'helpers/i18n'
import Component from 'components/TrackAssets/FormView/SelectCondition'

export default createSelectionListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: (params = {}) =>
      wrapItems(
        Object.entries(itemConditions).map(([key, value]) => ({
          id: key,
          displayName: t(value),
        }))
      ),
  }),
})(Component)
